<div id="zoom">
<div [hidden]="loadingOrders==false">
    <app-loading [loadingText]="loadingText"></app-loading>
</div>


<div style="margin: 20px;" [hidden]="loadingOrders==true">
  <div style="width: 50%; float: left;">
    <button mat-raised-button (click)="doOpenDialog('','createOT')" color="primary"
    style="margin: 0px 20px 10px 0px; float: left;">{{'GENERAL.ADD' | translate }}</button> 
    <mat-form-field style="width: 80%; float: left;">
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Buscar en la tabla..." style="width: 100%">
    </mat-form-field>
  </div>
  <div style="float: right; width: 50%;"> 
    <div *ngIf="userRole.includes('admin') || userRole.includes('orders-manager')" style="float: right;">
      <form [formGroup]="exportOrdersDataForm">
        <mat-form-field appearance="fill" style="float: left;">
          <mat-label>Inicio</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="initDate" (dateChange)="refreshExportDatesControls()">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill" style="float: left;">
          <mat-label>Fin</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="endDate" (dateChange)="refreshExportDatesControls()">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <span  matTooltip="Seleccionar fechas" [matTooltipDisabled]="initDate!=null && endDate!=null">
          <button mat-raised-button [disabled]="initDate==null || endDate==null" (click)="openDialog('',15,'')" color="primary" style="margin: 0px 20px 10px 20px;">{{'GENERAL.EXPORT_REPORT' | translate }}</button>
        </span>
      </form>
    </div>
  </div>
  <div style="clear: both;"></div>
  <mat-card>
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="orden">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Orden </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.orden}} </td>
        </ng-container>

        <ng-container matColumnDef="colada">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Colada </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.colada}} </td>
        </ng-container>

        <ng-container matColumnDef="clave">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Clave </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.clave}} </td>
        </ng-container>

        <ng-container matColumnDef="bono">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Bono </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.bono}} </td>
        </ng-container>

        <ng-container matColumnDef="modelo">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Modelo </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.modelo.modelo}} </td>
        </ng-container>

        <ng-container matColumnDef="disp">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Horno </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.disp}} </td>
        </ng-container>

        <ng-container matColumnDef="inicio">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Inicio </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.inicio | getDatePipe}} </td>
        </ng-container>

        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Finalización </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.fin | getDatePipe}} </td>
        </ng-container>

        <ng-container matColumnDef="duracion">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Duración </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{ element.duracion ?
            (element.duracion/60).toFixed(3) + ' Hrs': ('GENERAL.NOT_FINISHED' | translate )}} </td>
        </ng-container>

        <ng-container matColumnDef="piezas">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Piezas </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.piezas}} </td>
        </ng-container>

        <ng-container matColumnDef="kgs">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Kgs </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.kgs | getToFixed}} </td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Estado </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.estado_translated }} </td>
        </ng-container>

        <ng-container matColumnDef="visualizar">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Visualizar </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;">
            <mat-icon (click)="openDialog(element, 2, element)" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon blue-icon" title="Proceso">running_with_errors</mat-icon>
            <!--<mat-icon (click)="openDialog(element, 3, element)" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon gray-icon" title="Documentos">find_in_page</mat-icon>-->
            <mat-icon (click)="openDialog(element, 4, element)" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon blue-icon" title="Comentarios">message</mat-icon>
            <mat-icon (click)="openDialog(element, 5, element)" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon blue-icon" title="Muestras">biotech</mat-icon>
            <mat-icon (click)="openDialog(element, 6, element)" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon blue-icon" title="Bandejas">view_cozy</mat-icon>
            <mat-icon (click)="openDialog(element._id, 7, element)" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon blue-icon" title="Informes">feed</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Acciones </th>
          <td mat-cell *matCellDef="let element" style="text-align: center;">
            <mat-icon (click)="doOpenDialog(element,'editOT')" style="margin: 5px 2px"
              class="pointer unselectable verticalCenteredIcon blue-icon">edit</mat-icon>
            <mat-icon (click)="openDialog(element, 1, element)" color="warn" style="margin: 5px 2px;"
              class="pointer unselectable verticalCenteredIcon">delete_forever</mat-icon>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons aria-label="Select page">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
</div>